import { tap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MessageService } from '../message.service';
import { DeleteCommand, standardCommand, CommandBase } from '../../model/command';
import { ICommandHandler } from './command-handler-resolver.service';
import { Observable, of } from 'rxjs';
import { LanguageService } from '../language.service';

@Injectable()
export class DeleteCommandHandler implements ICommandHandler {
  constructor(
    private _messageService: MessageService,
    private readonly _languageService: LanguageService
  ) {}

  private _deleteFromItemsSource(item: any, itemsSource: any[]) {
    if (!item || !itemsSource) return;

    let index = itemsSource.indexOf(item);
    if (index >= 0) itemsSource.splice(index, 1);
  }

  canExecute(command: CommandBase): boolean {
    if (command.id === standardCommand.delete) {
      if (command instanceof DeleteCommand) {
        return command.itemsSource.indexOf(command.context) >= 0;
      }
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof DeleteCommand) {
      if (command.dataService) {
        return this._messageService
          .showDialog('DO_YOU_WANT_TO_DELETE_TEXT', { value: command.context.toString(this._languageService.currentLanguage) })
          .pipe(
            switchMap(dialogResult => {
              if (dialogResult) {
                return command.dataService
                  .delete(command.context.id)
                  .pipe(tap(() => this._deleteFromItemsSource(command.context, command.itemsSource)));
              }
            })
          );
      } else {
        return of(this._deleteFromItemsSource(command.context, command.itemsSource));
      }
    }
  }
}
